/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum OrganizationRawMaterialComplianceStatus {
  FULLY_COMPLIANT = "fully_compliant",
  CONDITIONALLY_COMPLIANT = "conditionally_compliant",
  COMPLIANCE_UNCERTAIN = "compliance_uncertain",
  NON_COMPLIANT = "non_compliant",
}
